/* eslint-disable */
import React, { useContext } from 'react';
import { Filters, Data } from '../contexts';
import { parseMoney } from '../../utils';
import { cardonator } from '../HOCs'
import { compensationFTE, peersAnalysisPerCustomerVals } from './KPIsHelper';

const PeopleCustomersKPIs = (props) => {
  const { filters } = useContext(Filters);
  const { ytd_months } = useContext(Data);
  let finalFilters = props.tabFilters || filters;
  let compareWith = finalFilters.compare_with;
  let avgCalcs = {};
  let numberCompare;
  if ((finalFilters && compareWith === 'Default:YOY') || (compareWith && compareWith.includes("Forecast"))) {
    numberCompare = 'n = 1'
  } else {
    if (finalFilters.display_columns_by === 'Years' && finalFilters.report_period !== 'Year to Date') {
      numberCompare = `n = ${props.aggregateData?.annual_n?.[props.year] ?? 0}`;
    } else {
      numberCompare = `n = ${props.aggregateData?.monthly_avg_n?.[props.year] ?? 0}`;
    }
  }
  const isAnnual = finalFilters.display_columns_by === 'Years' && finalFilters.report_period !== 'Year to Date';

  const getCalcsByType = (type) => {
    if (props.aggregateData) {
      return isAnnual ? props.aggregateData?.annual?.[type] : props.aggregateData?.monthly?.[type];
    } else {
      return isAnnual ? props.calcs?.[type] : props.monthly_calcs?.[type];
    }
  };

  if (compareWith === 'Peers') {
    avgCalcs = getCalcsByType('avg');
  } else if (compareWith === 'NSCHBC') {
    avgCalcs = getCalcsByType('nschbc');
  } else {
    avgCalcs = isAnnual ? props.calcs?.you : props.monthly_calcs?.you
  }

  const padding = '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0'
  let backgroundColor = '';
  let cellClass = '';
  let commonSizeValCellClass = 'common-size-cell';
  let tableClasses = '';

  if (props.page === 'people') {
    backgroundColor = '#8ADFFE';
    cellClass = 'people-table-cell';
    commonSizeValCellClass += ' people-table-cell';
    tableClasses = 'people-report-table';
  } else {
    backgroundColor = '#CDA5DE';
    cellClass = 'customers-table-cell';
    commonSizeValCellClass += ' customers-table-cell';
    tableClasses = 'customers-report-table';
  }

  const costOfTurnover = (whoseCalcs, y) => {
    const lostProductivity = .2;
    const lostProductivityTime = .125;
    const lostWagesTime = .125;
    const employeeProductivityDecline = .5;
    const employeeProductivityDeclineTime = .185;
    // Cost of Turnover Formula
    // (Your Turnover Rate(year) − Peer Turnover Rate(year)) 
    // * (Number of Employees(year) 
    // * ((Revenue Per Employee(year) * Lost Productivity * Lost Productivity Time) 
    //   + (Average Wages and Salaries(year) * Lost Wages Time ) 
    //   + ((.25 * Training(year))/Number of Employees(year))
    //   + (Revenue Per Employee(year) * Employee Productivity Decline * Employee Productivity Decline Time)))
    if (avgCalcs?.turnover_rate?.[y] && whoseCalcs && whoseCalcs?.turnover_rate?.[y] !== 0 && whoseCalcs?.total_number_of_employees?.[y] !== 0 && whoseCalcs?.revenue_per_employee?.[y] !== 0 && whoseCalcs?.average_wages_and_salaries?.[y] !== 0) {
      return ((whoseCalcs.turnover_rate[y] - avgCalcs.turnover_rate[y])
        * (whoseCalcs.total_number_of_employees[y]
          * ((whoseCalcs.revenue_per_employee[y] * lostProductivity * lostProductivityTime)
            + (whoseCalcs.average_wages_and_salaries[y] * lostWagesTime)
            + ((whoseCalcs.training[y] * .25) / whoseCalcs.total_number_of_employees[y])
            + (whoseCalcs.revenue_per_employee[y] * employeeProductivityDecline * employeeProductivityDeclineTime))));
    } else return undefined
  }

  let peopleKpis = props.reportMetrics['people_kpi']
  let customersKpis = props.reportMetrics['customers_kpi']

  const buildRowsArray = (reportPeriod, displayColumnsBy, compareFilter) => {
    const rows = []
    let arrayOfMetrics = props.page === 'people' ? peopleKpis : customersKpis;
    let compareCalcs = avgCalcs
    let specificIndustryMetrics = ['number_of_hygienists', 'number_of_assistants', 'number_of_office_employees', 'number_of_dentists', 'number_of_nurses', 'number_of_doctors'];
    let analysisPerClientMetrics = ['revenue_per_customer', 'gross_profit', 'gross_profit_per_customer', 'operating_expenses_net_income', 'operating_expenses_net_income_per_customer'];

    if (displayColumnsBy === 'Years') {
      if (reportPeriod !== 'Year to Date') {
        arrayOfMetrics.forEach(set => {
          if (set['display'] || set['yearsView']) {
            let helperObj = {
              key: set.key,
              title: set.title || set.copy,
              format: set.format,
              checked: set.checked,
              padding: set.padding,
              header: set.header
            }

            props.yearRange.forEach(y => {
              if (specificIndustryMetrics.includes(set.key)) {
                helperObj['industryValue' + y] = props.calcs?.['you']?.[set.key]?.[y] || null;
                helperObj['industryValueCompare' + y] = compareCalcs?.[set.key]?.[y] || null;
                helperObj[y] = props.calcs?.['you']?.[set.key] ? compensationFTE(props.naicsCode, props.calcs?.['you'], set.key, y) : null;
                helperObj[y + 'compare'] = compareCalcs && compareCalcs?.[set.key] ? compensationFTE(props.naicsCode, compareCalcs, set.key, y) : null;
              } else if (analysisPerClientMetrics.includes(set.key)) {
                helperObj[y] = props.calcs?.['you']?.[set.key]?.[y] || null;
                helperObj[y + 'compare'] = compareCalcs && compareCalcs?.[set.key] ? peersAnalysisPerCustomerVals(set.key, y, compareCalcs) : null;
              } else if (set.key !== 'title' && set.key !== 'cost_of_turnover' && set.key !== 'number_of_employees_who_left') {
                helperObj[y] = props.calcs?.['you']?.[set.key]?.[y] || null;
                helperObj[y + 'compare'] = compareCalcs && compareCalcs?.[set.key] ? compareCalcs?.[set.key]?.[y] : null;
              } else if (set.key === 'cost_of_turnover') {
                helperObj[y] = costOfTurnover(props.calcs?.['you'], y)
                helperObj[y + 'compare'] = costOfTurnover(compareCalcs, y)
              } else if (set.key === 'number_of_employees_who_left') {
                helperObj[y] = props.calcs?.['you']?.['turnover_rate']?.[y] * props.calcs?.['you']?.['total_number_of_employees']?.[y]
                helperObj[y + 'compare'] = compareCalcs && compareCalcs?.['turnover_rate'] ? compareCalcs?.['turnover_rate']?.[y] * compareCalcs?.['total_number_of_employees']?.[y] : null;
              } else {
                helperObj[y] = null
              }
            })

            rows.push(helperObj)
          }
        })
      } else {
        // YTD section
        let lastMonthNumber = ytd_months[ytd_months.length - 1];

        arrayOfMetrics.forEach(set => {
          if (set['display'] || set['ytdView']) {
            let helperObj = {
              key: set.key,
              title: set.title || set.monthlyCopy || set.copy,
              format: set.format,
              checked: set.checked,
              padding: set.padding,
              header: set.header
            }

            const ytdAr = [props.year - 1, props.year]

            ytdAr.forEach(y => {
              if (set.header) {
                helperObj[y] = ''
                helperObj[y + 'compare'] = ''
              } else {
                if (y === props.year) {
                  helperObj[y] = props.youMetrics.hasOwnProperty([set.key]) ? props.youMetrics[set.key][lastMonthNumber] : null
                  if (props.compareMetrics[set.key] !== undefined) {
                    helperObj[y + 'compare'] = props.compareMetrics.hasOwnProperty([set.key]) ? props.compareMetrics[set.key][lastMonthNumber] : null
                  } else {
                    helperObj[y + 'compare'] = null
                  }
                } else {
                  helperObj[y] = props.youPreviousYearMetricsYTD.hasOwnProperty([set.key]) ? props.youPreviousYearMetricsYTD[set.key][lastMonthNumber] : null
                  if (props.compareMetrics[set.key] !== undefined) {
                    helperObj[y + 'compare'] = props.comparePreviousYearMetricsYTD.hasOwnProperty([set.key]) ? props.comparePreviousYearMetricsYTD[set.key][lastMonthNumber] : null
                  } else {
                    helperObj[y + 'compare'] = null
                  }
                }
              }
            })
            rows.push(helperObj)
          }
        })
      }

    } else {
      const endMonthOfSelectedYear = finalFilters?.date_through_monthly_month && finalFilters?.date_through_monthly_year ? Number(finalFilters.date_through_monthly_month) : 12
      let lastMonthNumber = 0;
      let useableMonths = props.monthly_calcs?.['you']?.['roa']?.[props.year] ? Object.values(props.monthly_calcs['you']['roa'][props.year]).slice(0, endMonthOfSelectedYear) : [];
      useableMonths.forEach(thing => thing !== null ? lastMonthNumber += 1 : null);
      // monthly array
      arrayOfMetrics.forEach(set => {
        if (set['display'] || set['monthlyView']) {
          let helperObj = {
            key: set.key,
            title: set.title || set.monthlyCopy || set.copy,
            format: set.format,
            checked: set.checked,
            padding: set.padding,
            header: set.header
          }

          Object.keys(props.monthsObj).forEach((m, i) => {
            if (set?.header) {
              helperObj['youYTD'] = ''
              helperObj['compare'] = ''
            } else {
              let monthNumber = m
              helperObj[monthNumber] = props.youMetrics?.[set.key]?.[monthNumber] ? props.youMetrics[set.key][monthNumber] : null
            }
          })
          helperObj['youYTD'] = props.youMetrics?.[set.key]?.[lastMonthNumber] || null
          helperObj['compare'] = props.compareMetrics?.[set.key]?.[lastMonthNumber] || null
          helperObj['lastMonthNumber'] = lastMonthNumber
          rows.push(helperObj)
        }
      })
    }
    return rows
  }


  const buildBodyYears = (reportPeriod) => {
    let rows = buildRowsArray(reportPeriod, finalFilters.display_columns_by, compareWith)

    if (reportPeriod !== 'Year to Date') {
      return rows.map(row => {
        let rowChecked = row.checked && props.reportMetrics['editMetrics'] ? <p style={{ 'margin': 0 }}>&#10004;</p> : ''
        let finalCopy = ''
        if (props.page === 'people') {
          finalCopy = row['padding'] + row['title']
        } else {
          finalCopy = row['format'] !== 'header' ? padding + row['title'] : row['title']
        }

        return (
          <tr key={Math.random(24)} onClick={() => props.reportMetrics['editMetrics'] ? props.handleSelectAndLayout(props.page, 'kpi', row.key) : null}>
            {!props.pdf ? <td>{rowChecked}</td> : null}
            <td className='people-cus-kpi-table-copy'>{finalCopy}</td>
            {props.yearRange.map((y, i) => {
              let backgroundStyle = {}
              let tableCellClass = '';
              if (i % 2 === 0 && (!props.pdf || (props.pdf && props.yearRange.length !== 2))) {
                backgroundStyle['backgroundColor'] = backgroundColor;
                tableCellClass = cellClass;
              }
              let industryValue = row['industryValue' + y] ? row['industryValue' + y] : '';
              let industryValueCompare = row['industryValueCompare' + y] ? Math.round(row['industryValueCompare' + y]) : '';
              let value;
              let valueCompare;

              switch (row.format) {
                case 'currency':
                case 'money':
                  value = parseMoney(row[y])
                  valueCompare = parseMoney(row[y + 'compare'])
                  break;
                case 'percent':
                  value = row[y] ? row[y].toFixed(2) + '%' : '-'
                  valueCompare = row[y + 'compare'] ? row[y + 'compare'].toFixed(2) + '%' : '-'
                  break;
                case 'header':
                  value = ''
                  valueCompare = ''
                  break;
                default:
                  value = row[y] ? row[y].toFixed(0) : '-';
                  valueCompare = row[y + 'compare'] ? row[y + 'compare'].toFixed(0) : '-';
                  break;
              }

              if (row.header) {
                value = ''
                valueCompare = ''
              }

              return (
                <React.Fragment key={Math.random(80)}>
                  <td className={tableCellClass} style={backgroundStyle}>{industryValue}</td>
                  <td className={tableCellClass} style={backgroundStyle}>{value}</td>
                  <td className={tableCellClass} style={backgroundStyle}></td>
                  <td className={tableCellClass} style={backgroundStyle}>{industryValueCompare}</td>
                  <td className={tableCellClass} style={backgroundStyle}>{valueCompare}</td>
                  <td></td>
                </React.Fragment>
              )
            })}
          </tr>
        )
      })
    } else {
      // Year to Date display section
      return rows.map(row => {
        let rowChecked = row.checked && props.reportMetrics['editMetrics'] ? <p style={{ 'margin': 0 }}>&#10004;</p> : ''
        let finalCopy = ''
        if (props.page === 'people') {
          finalCopy = row['padding'] + row['title']
        } else {
          finalCopy = row['format'] !== 'header' ? padding + row['title'] : row['title']
        }

        return (
          <tr key={Math.random(24)} onClick={() => props.reportMetrics['editMetrics'] ? props.handleSelectAndLayout(props.page, 'kpi', row.key) : null}>
            {!props.pdf ? <td>{rowChecked}</td> : null}
            <td className='people-cus-kpi-table-copy'>{finalCopy}</td>
            {[props.year - 1, props.year].map((y, i) => {
              let backgroundStyle = {}
              let valueCellClass = '';
              if (i % 2 === 0) {
                backgroundStyle['backgroundColor'] = backgroundColor
                valueCellClass = cellClass;
              }
              let value;
              let valueCompare;

              switch (row.format) {
                case 'money':
                  value = parseMoney(row[y])
                  valueCompare = parseMoney(row[y + 'compare'])
                  break;
                case 'percent':
                  value = row[y] ? (row[y] * 100).toFixed(2) + '%' : '-'
                  valueCompare = row[y + 'compare'] ? (row[y + 'compare'] * 100).toFixed(2) + '%' : '-'
                  break;
                case 'header':
                  value = ''
                  valueCompare = ''
                  break;
                case 'roundedDecimal':
                  value = row[y] ? Math.round(row[y]) : '-'
                  valueCompare = row[y + 'compare'] ? Math.round(row[y + 'compare']) : '-'
                default:
                  value = row[y] ? Math.round(row[y]) : '-'
                  valueCompare = row[y + 'compare'] ? Math.round(row[y + 'compare']) : '-'
                  break;
              }

              if (row.header) {
                value = ''
                valueCompare = ''
              }

              return (
                <React.Fragment key={Math.random(80)}>
                  {i === 1 ? <td></td> : null}
                  <td className={valueCellClass} style={backgroundStyle}>{value}</td>
                  {compareWith === 'Default:None' || compareWith === 'None' ? null : <td className={valueCellClass} style={backgroundStyle}></td>}
                  {compareWith === 'Default:None' || compareWith === 'None' ? null : <td className={valueCellClass} style={backgroundStyle}>{valueCompare}</td>}
                </React.Fragment>
              )
            })}
          </tr>
        )
      })
    }
  }

  const buildBodyMonths = (reportPeriod) => {
    let rows = buildRowsArray(reportPeriod, finalFilters.display_columns_by, compareWith)

    return rows.map(row => {
      let rowChecked = row.checked && props.reportMetrics['editMetrics'] ? <p style={{ 'margin': 0 }}>&#10004;</p> : ''
      let youYTD;
      let valueCompare;
      let finalCopy = ''
      if (props.page === 'people') {
        finalCopy = row['padding'] + row['title']
      } else {
        finalCopy = row['format'] !== 'header' ? padding + row['title'] : row['title']
      }

      switch (row.format) {
        case 'money':
          youYTD = parseMoney(row['youYTD'])
          valueCompare = parseMoney(row['compare'])
          break;
        case 'percent':
          youYTD = row['youYTD'] ? (row['youYTD'] * 100).toFixed(2) + '%' : ''
          valueCompare = row['compare'] ? (row['compare'] * 100).toFixed(2) + '%' : ''
          break;
        case 'header':
          youYTD = ''
          valueCompare = ''
          break;
        case 'roundedDecimal':
          youYTD = row['youYTD'] ? Math.round(row['youYTD']) : ''
          valueCompare = row['compare'] ? Math.round(row['compare']) : ''
          break;
        default:
          youYTD = row['youYTD'] ? Math.round(row['youYTD']) : '-';
          valueCompare = row['compare'] ? Math.round(row['compare']) : '';
          break;
      }

      return (
        <tr key={Math.random(24)} onClick={() => props.reportMetrics['editMetrics'] ? props.handleSelectAndLayout(props.page, 'kpi', row.key) : null}>
          {!props.pdf ? <td>{rowChecked}</td> : null}
          <td className='people-cus-kpi-table-copy'>{finalCopy}</td>
          {Object.keys(props.monthsObj).map((month, i) => {
            let value;
            switch (row.format) {
              case 'money':
                value = parseMoney(row[i + 1])
                break;
              case 'percent':
                value = row[i + 1] ? (row[i + 1] * 100).toFixed(2) + '%' : '0%'
                break;
              case 'header':
                value = ''
                break;
              case 'roundedDecimal':
                value = row[i + 1] ? Math.round(row[i + 1]) : ''
                break;
              default:
                value = row[i + 1] ? Math.round(row[i + 1]) : ''
                break;
            }
            if (row.header) { value = '' }
            return <td key={Math.random(80)}>{month <= row.lastMonthNumber ? value : ''}</td>
          })}
          <td>{youYTD}</td>
          {
            compareWith === 'Default:None' || compareWith === 'None'
              ? null
              : <React.Fragment key={Math.random(80)}>
                <td></td>
                <td>
                  {valueCompare}
                </td>
              </React.Fragment>
          }
          <td></td>
        </tr>
      )
    })
  }

  const renderYearHeaderColumns = (displayColumnsBy, reportPeriod) => {
    const currentYear = new Date().getFullYear();
    let monthsHeaders;
    let formatedYearsRow = [];
    let youPeersRow = [];

    if (displayColumnsBy === 'Years') {
      if (reportPeriod !== 'Year to Date') {
        props.yearRange.forEach((y, i) => {
          const year = Number(y);
          let arrowCellClass = 'common-size-arrow ';
          let backgroundStyle = {}
          let commonSizeValCellClass = 'common-size-cell ';
          let youDate, compareDate = '';

          if (year === currentYear) {
            youDate = props.companyYTDDate;
            compareDate = props.aggregateYTDDate;
          } else {
            youDate = props.calendarYearEnd ? `${props.fiscalYearEnd}/${year}` : props.fiscalYearEnd ? `${props.fiscalYearEnd}/${year + 1}` : `12/31/${year}`;
            compareDate = `12/31/${year}`;
          }

          if (i % 2 === 0 && (!props.pdf || (props.pdf && props.yearRange.length !== 2))) {
            arrowCellClass += cellClass;
            backgroundStyle['backgroundColor'] = backgroundColor
            commonSizeValCellClass += cellClass;
          }

          youPeersRow.push(
            <React.Fragment key={Math.random(i) + 'tcpc-year-headers'}>
              <td colSpan='2' className={commonSizeValCellClass} style={backgroundStyle}>You</td>
              <td className={arrowCellClass} style={backgroundStyle}></td>
              <td colSpan='2' className={commonSizeValCellClass} style={backgroundStyle}>Peers</td>
              <td className='space-cell'></td>
            </React.Fragment>
          )

          formatedYearsRow.push(
            <React.Fragment key={Math.random(i) + 'tcpc-year-headers'}>
              <td colSpan='2' className={commonSizeValCellClass} style={backgroundStyle}>{youDate}</td>
              <td className={arrowCellClass} style={backgroundStyle}></td>
              <td colSpan='2' className={commonSizeValCellClass} style={backgroundStyle}>{compareDate}</td>
              <td className='space-cell'></td>
            </React.Fragment>
          )
        })

        return (
          <thead>
            <tr key={Math.random(20)}>
              {!props.pdf ? <td className='edit-metrics-cell' onClick={() => props.handleEditMetrics()}>{props.reportMetrics['editMetrics'] ? <i className='fa fa-save hide-on-print' style={{ 'fontSize': '2em' }}></i> : <i className='fa fa-pencil edit-icon hide-on-print' style={{ 'fontSize': '2em' }}></i>}</td> : null}
              <td></td>
              {youPeersRow}
            </tr>
            <tr key={Math.random(20)}>
              {!props.pdf ? <td></td> : null}
              <td></td>
              {formatedYearsRow}
              {props.yearRange.length === 2 ? <td></td> : null}
            </tr>
          </thead>
        )
      } else {
        // YTD Headers
        return (
          <thead>
            <tr>
              {!props.pdf ? <td className='edit-metrics-cell' onClick={() => props.handleEditMetrics()}>{props.reportMetrics['editMetrics'] ? <i className='fa fa-save hide-on-print' style={{ 'fontSize': '2em' }}></i> : <i className='fa fa-pencil edit-icon hide-on-print' style={{ 'fontSize': '2em' }}></i>}</td> : null}
              <td></td>
              <td colSpan={compareWith === 'Default:None' || compareWith === 'None' ? '1' : '3'} className={cellClass} style={{ 'backgroundColor': backgroundColor }}>{`YTD ${props.clientFirstYearMonth}/${props.year - 1}`}</td>
              <td></td>
              <td colSpan={compareWith === 'Default:None' || compareWith === 'None' ? '1' : '3'}>{`YTD ${props.clientSecondYearMonth}/${props.year}`}</td>
            </tr>
            <tr>
              {!props.pdf ? <td></td> : null}
              <td></td>
              <td className={`common-size-cell ${cellClass}`} style={{ 'backgroundColor': backgroundColor }}>You</td>
              {compareWith === 'Default:None' || compareWith === 'None' ? null : <td className={`common-size-cell ${cellClass}`} style={{ 'backgroundColor': backgroundColor }}></td>}
              {compareWith === 'Default:None' || compareWith === 'None' ? null : <td className={`common-size-cell ${cellClass}`} style={{ 'backgroundColor': backgroundColor }}>Peers</td>}
              <td></td>
              <td className='common-size-cell'>You</td>
              {compareWith === 'Default:None' || compareWith === 'None' ? null : <td className='common-size-cell'></td>}
              {compareWith === 'Default:None' || compareWith === 'None' ? null : <td className='common-size-cell'>Peers</td>}
              <td></td>
            </tr>
          </thead>
        )
      }
    } else {
      let youTitle = finalFilters.report_period === 'Trailing 12' ? `You T12 ${props.year}` : 'You YTD'
      let YOYyearDisplay = props.calendarYearEnd ? props.year - 1 : props.year
      let compareTitle = null
      if (compareWith && compareWith.includes('Forecast') && finalFilters.report_period !== 'Trailing 12') {
        compareTitle = props.monthlyCompareWithTitle
      } else if (compareWith === 'Default:Peers' && finalFilters.report_period !== 'Trailing 12') {
        compareTitle = 'Peers Avg'
      } else if (compareWith === 'Default:YOY' && finalFilters.report_period !== 'Trailing 12') {
        compareTitle = `YOY ${YOYyearDisplay}`
      } else if (finalFilters.report_period === 'Trailing 12' && compareWith !== 'Default:None') {
        compareTitle = `T12 ${props.year - 1}`
      }
      // Months Headers
      monthsHeaders = Object.values(props.monthsObj).map(month => {
        return <td key={Math.random(80) + 'tcpc-months-headers'}>{month}</td>
      })
      monthsHeaders.push(
        <React.Fragment key={Math.random(20) + 'tcpc-months-headers'}>
          <td>{youTitle}</td>
          {
            compareWith === 'Default:None' || compareWith === 'None'
              ? null
              : (
                <React.Fragment key={Math.random(80)}>
                  <td></td>
                  <td>{compareTitle}</td>
                </React.Fragment>
              )
          }
        </React.Fragment>
      )

      return (
        <thead>
          <tr key={Math.random(20)}>
            {!props.pdf ? <td className='edit-metrics-cell' onClick={() => props.handleEditMetrics()}>{props.reportMetrics['editMetrics'] ? <i className='fa fa-save hide-on-print' style={{ 'fontSize': '2em' }}></i> : <i className='fa fa-pencil edit-icon hide-on-print' style={{ 'fontSize': '2em' }}></i>}</td> : null}
            <td></td>
            {monthsHeaders}
          </tr>
        </thead>
      )
    }
  }

  const buildTable = (displayColumnsBy, reportPeriod) => {
    if (props.pdf) {
      let annualView2Yrs = displayColumnsBy === 'Years' && reportPeriod !== 'Year to Date'
      let pageViewClass = annualView2Yrs && props.yearRange.length === 2 ? 'portrait-view' : 'landscape-view'
      let printViewClass = annualView2Yrs && props.yearRange.length === 2 ? 'money-pdf-portrait' : 'report-pdf-landscape'
      let clientNames = props.realName ? `${props.realName} / ${props.clientName}` : props.clientName
      let yearRangeText = annualView2Yrs ? `${props.yearRange[0]} - ${props.yearRange[props.yearRange.length - 1]}` : finalFilters.year
      let pageTitle = props.page.charAt(0).toUpperCase() + props.page.slice(1);

      const tabName = (props.tabName || pageTitle || '').trim().toLowerCase();
      const title = (pageTitle || '').trim().toLowerCase();
      let reportTitle = tabName.includes(title) ? props.tabName : `${props.tabName}, ${props.title} Key Performance Indicators`;
      let naicsCode = finalFilters.code;
      let dataType = finalFilters.datatype;
      let revenueBand = finalFilters.revenue_band;
      let region = finalFilters.region;
      let numOfDocs = finalFilters.number_of_pros || 'All'
      let filtersTitle;

      if (displayColumnsBy === 'Months' || reportPeriod === 'Year to Date') {
        const compareParts = finalFilters.compare_with.split(':');
        let compare = compareParts.length > 1 ? compareParts.slice(1).join(':').trim() : finalFilters.compare_with;
        filtersTitle = `NAICS: ${naicsCode}, Data Type: ${dataType}, Revenue: ${revenueBand}, Region: ${region}, Report Period: ${reportPeriod}, Compare with: ${compare}`;
      } else {
        let compare = finalFilters.compare_with
        filtersTitle = `NAICS: ${naicsCode}, Data Type: ${dataType}, Revenue: ${revenueBand}, Region: ${region}, Compare with: ${compare}`;
      }

      return (
        <div className={pageViewClass}>
          <div className={printViewClass}>
            <div>
              {
                annualView2Yrs && props.yearRange.length === 2
                  ? (
                    <div>
                      <p className='report-annual-title'>{reportTitle}</p>
                      <p className='report-company-title'>{clientNames}</p>
                      <p className='report-year-range-title'>{yearRangeText}</p>
                      <p className='report-filters-title'>{filtersTitle}</p>
                    </div>
                  )
                  : <div>
                    <p className='report-annual-title'>{`${reportTitle}, ${clientNames}, ${yearRangeText}`}</p>
                    <p className='report-filters-title'>{filtersTitle}</p>
                  </div>
              }
              <div className='money-pdf-table-div'>
                <table style={{ whiteSpace: 'pre' }} className='money-pdf-table' >
                  {renderYearHeaderColumns(displayColumnsBy, reportPeriod)}
                  <tbody>
                    {displayColumnsBy === 'Years' ? buildBodyYears(reportPeriod) : buildBodyMonths(reportPeriod)}
                    <tr><td className='footer-cell'><i>{numberCompare}</i></td></tr>
                  </tbody>
                </table>
              </div>
            </div>
            <p className='pdf-disclaimer-text'>{`These financial statements have been prepared by ${props.firmName}, and have not been subjected to an audit or review or compilation engagement, and no assurance is provided on them. These financial statements are intended for management’s internal use only. Substantially all disclosures omitted.`}</p>
          </div>
        </div>
      )
    } else {
      return (
        <div className='people-customers-pdf'>
          <h1 className='report-table-title hide-not-on-print'>Key Performance Indicators - {props.clientName}</h1>
          <div className='money-report-container'>
            <table style={{ whiteSpace: 'pre' }} className={tableClasses} >
              {renderYearHeaderColumns(displayColumnsBy, reportPeriod)}
              <tbody>
                {displayColumnsBy === 'Years' ? buildBodyYears(reportPeriod) : buildBodyMonths(reportPeriod)}
              </tbody>
              <tfoot>
                <tr>
                  <td><i>{numberCompare}</i></td>
                </tr>
                {['Peers', 'NSCHBC', 'Default:Peers'].includes(compareWith) ? <tr><td colSpan='2' className='peer-disclaimer'>Peer data is updated monthly on or after the 16th.</td></tr> : null}
              </tfoot>
            </table>
          </div>
        </div>
      )
    }

  }

  return (buildTable(finalFilters.display_columns_by, finalFilters.report_period))
}

export default cardonator(PeopleCustomersKPIs);